import { Model } from '@vuex-orm/core'

export default class Careersite extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'careersites'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      name: this.attr(null),
      status: this.attr(null),
      slug: this.attr(null),
      careersitebuilder_url: this.attr(null),
      careersite_url: this.attr(null),
      is_legacy: this.attr(false),
      total_jobs: this.attr(0),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Careersite.js